import { Component, Input, OnInit, Output, EventEmitter, SimpleChange } from '@angular/core';
import { FormControl } from '@angular/forms';
import { of } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { QuestionDefinition, QuestionValueChange, SelectInputType } from '../../forms/form.types';
import { GradingScheduleService } from '../../shared/grading-schedule.service';
import { GradingSchedule } from '../../shared/interface/grading-schedule.interface';
import { SelectListOption } from '../../shared/shared.types';

@Component({
    selector: 'app-object-list-term-list',
    templateUrl: './term-list.component.html',
    styleUrls: ['./term-list.component.scss']
})
export class TermListComponent implements OnInit {
    @Input() initialEmptyRow: boolean = false;
    @Input() termCode: string;
    @Input() enabled: boolean = false;
    @Input() section: string = '';
    @Input() includeSectionsQuestion: boolean = true;
    @Input() showTermNotAvailable: boolean = false;

    @Output() selectedTermCode = new EventEmitter<string>();
    @Output() sectionChangeEvent = new EventEmitter<string>();
    questionCss: string = 'large-12 medium-12 small-12 column align-right';

    private sectionOptions: Observable<Array<SelectListOption>> = of([
        {
            text: 'All Sections',
            value: ''
        },
        {
            text: 'Gradable Sections',
            value: 'gradable'
        },
        {
            text: 'Non-Gradable Sections',
            value: 'non_gradable'
        }
    ]);

    termList: Array<GradingSchedule>;
    controls: {
        termCode: FormControl<string>;
        section: FormControl<string>;
    };

    questions: {
        termCode: QuestionDefinition;
        section: QuestionDefinition;
    };

    private options: Array<SelectListOption> = [];

    constructor(private gradingScheduleService: GradingScheduleService) {
        this.getTermList();
    }

    ngOnInit(): void {
        this.controls = {
            termCode: new FormControl<string>(null),
            section: new FormControl<string>('')
        };
        this.questions = {
            termCode: {
                input: {
                    discriminator: 'SELECT',
                    property: 'termCode',
                    label: 'Select a Term',
                    control: this.controls.termCode,
                    optionsCallBack: {
                        this: this,
                        function: this.renderOptions
                    },
                    required: true
                }
            },
            section: {
                input: {
                    discriminator: 'SELECT',
                    property: 'section',
                    label: 'Section',
                    control: this.controls.section,
                    options$: this.sectionOptions
                }
            }
        };

        if (this.termCode) {
            this.questions.termCode.input.control.setValue(this.termCode);
        }
        if (this.includeSectionsQuestion) {
            this.questionCss = 'large-6 medium-6 small-12 column';
        }
    }

    ngAfterViewInit(): void {}

    getTermList(): void {
        this.gradingScheduleService.getTermList().subscribe((response: Array<GradingSchedule>) => {
            this.termList = response;
            (this.questions.termCode.input as SelectInputType).updateOptions = true;
        });
    }

    private renderOptions(): Observable<Array<SelectListOption>> {
        if (this.termList?.length) {
            this.options = this.termList?.map((m) => {
                return {
                    text:
                        !m.enabled && this.showTermNotAvailable
                            ? `${m.termDescription} (Grading Closed)`
                            : m.termDescription,
                    value: m.termCode
                } as SelectListOption;
            });
        }
        return of(this.options);
    }

    onChange($event: QuestionValueChange): void {
        this.selectedTermCode.emit($event.payload);
    }

    ngOnChanges(change: SimpleChange) {
        this.questions?.termCode?.input?.control?.setValue(this?.termCode);
        if (this.includeSectionsQuestion && this.section) {
            this.questions?.section?.input?.control?.setValue(this.section);
        }

        if (this.enabled) {
            this.questions?.termCode?.input?.control?.enable();
            this.questions?.section?.input?.control?.enable();
        } else {
            this.questions?.termCode?.input?.control?.disable();
            this.questions?.section?.input?.control?.disable();
        }
    }

    onSectionChange($event: QuestionValueChange) {
        this.sectionChangeEvent.emit($event.payload);
    }
}
